/**
 * Recurring enrollment progress semantics (shared, testable).
 *
 * The Client Profile shows recurring-program progress using the AUTHORITATIVE
 * enrollment counters (`completedOccurrences` / `totalOccurrences`) from
 * `companies/{companyId}/leads/{leadId}/enrollments`.
 *
 * Display convention is the explicit COMPLETED-COUNT form to remove the
 * ambiguity of a bare "1 of 3" (which could read as "on visit 1" or
 * "one visit done"):
 *
 *   completed=0, total=3 → "0 of 3 completed"
 *   completed=1, total=3 → "1 of 3 completed"
 *   completed=2, total=3 → "2 of 3 completed"
 *   completed=3, total=3 → "3 of 3 completed · Program complete"
 *   total=null           → "N completed" (unlimited program)
 *
 * The counter never exceeds the total's meaning — when completed >= total the
 * program-complete state is shown (never "4 of 3").
 */

export function isProgramComplete(completed, total) {
  if (total == null) return false;
  const c = Number(completed) || 0;
  const t = Number(total);
  return Number.isFinite(t) && t > 0 && c >= t;
}

export function formatEnrollmentProgress(completed, total) {
  const c = Number(completed) || 0;
  if (total == null) return `${c} completed`;
  const t = Number(total) || 0;
  const base = `${c} of ${t} completed`;
  return isProgramComplete(c, t) ? `${base} · Program complete` : base;
}
